import http from "./http.service";

/** Sobre qué corre una oferta. Tiene que coincidir con `OfertaAlcance` del back. */
export const ALCANCE = {
    PRODUCTOS: "PRODUCTOS",
    MARCA_MODELO: "MARCA_MODELO",
    BAJA: "BAJA",
};

/** Cómo se calcula el descuento. Tiene que coincidir con `OfertaTipo` del back. */
export const TIPO_OFERTA = {
    PORCENTAJE: "PORCENTAJE",
    IMPORTE_FIJO: "IMPORTE_FIJO",
    PRECIO_FIJO: "PRECIO_FIJO",
};

/**
 * El estado que muestra el listado. Es derivado de `activa` + las fechas y lo calcula el back: acá
 * sólo se lo pinta, así que si se agrega uno hay que agregarlo en los dos lados.
 */
export const ESTADO_OFERTA = {
    VIGENTE: "VIGENTE",
    PROGRAMADA: "PROGRAMADA",
    VENCIDA: "VENCIDA",
    PAUSADA: "PAUSADA",
};

/**
 * Las ofertas del vendedor.
 *
 * <p>Las publicaciones alcanzadas van por endpoints aparte y no dentro del cuerpo de la oferta: se
 * agregan de a muchas y por filtro, no como una lista de ids dentro del formulario.
 */
class OfertasService {

    buscar(searchDTO: any): Promise<any> {
        return http.post("/api/vendedor/ofertas/buscar", searchDTO);
    }

    detalle(id: number): Promise<any> {
        return http.get(`/api/vendedor/ofertas/${id}`);
    }

    crear(oferta: any): Promise<any> {
        return http.post("/api/vendedor/ofertas", oferta);
    }

    actualizar(id: number, oferta: any): Promise<any> {
        return http.put(`/api/vendedor/ofertas/${id}`, oferta);
    }

    cambiarActiva(id: number, activa: boolean): Promise<any> {
        return http.put(`/api/vendedor/ofertas/${id}/activa`, {activa});
    }

    eliminar(id: number): Promise<any> {
        return http.delete(`/api/vendedor/ofertas/${id}`);
    }

    /** Las bajas del vendedor, para el combo del alcance BAJA. Lista corta: no se pagina. */
    bajas(): Promise<any> {
        return http.get("/api/vendedor/ofertas/bajas");
    }

    /** Las publicaciones que están adentro de la oferta. */
    productos(id: number, searchDTO: any): Promise<any> {
        return http.post(`/api/vendedor/ofertas/${id}/productos/buscar`, searchDTO);
    }

    /** El catálogo del vendedor para elegir, con la marca de lo que ya está adentro. */
    candidatos(id: number, searchDTO: any): Promise<any> {
        return http.post(`/api/vendedor/ofertas/${id}/productos/candidatos`, searchDTO);
    }

    agregar(id: number, productoIds: number[]): Promise<any> {
        return http.post(`/api/vendedor/ofertas/${id}/productos`, {productoIds});
    }

    /** Suma todo lo que coincide con el filtro actual: viaja el filtro, no los ids. */
    agregarFiltrados(id: number, searchDTO: any): Promise<any> {
        return http.post(`/api/vendedor/ofertas/${id}/productos/agregar-filtrados`, searchDTO);
    }

    quitar(id: number, productoIds: number[]): Promise<any> {
        return http.post(`/api/vendedor/ofertas/${id}/productos/quitar`, {productoIds});
    }

    quitarTodos(id: number): Promise<any> {
        return http.delete(`/api/vendedor/ofertas/${id}/productos`);
    }
}

const ofertasService = new OfertasService();
export default ofertasService;
